import apiConfig from './config';
import helper from '../../utils/helper';

const getReportes = (queryString, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/cuota-ordinaria${queryString}&empresa_id=${apiConfig.constants.EMPRESA_ID}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getReporteHC = (id, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${id}?fondo_mutual=false`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getReportePagoPendiente = (id, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${id}?pago_pendiente=true`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getReporte = (id, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${id}?fondo_mutual=true`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const createReporte = (data, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes`, {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const updateReporte = (data, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === 'files' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files[${index}]`, item);
      });
    } else if (key === 'files_titulo' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_titulo[${index}]`, item);
      });
    } else if (key === 'files_fotografia' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_fotografia[${index}]`, item);
      });
    } else if (key === 'files_dni' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_dni[${index}]`, item);
      });
    } else if (key === 'files_poliza' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_poliza[${index}]`, item);
      });
    } else if (key === 'files_declaracion_jurada' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_declaracion_jurada[${index}]`, item);
      });
    } else if (key === 'files_titular_poliza_decano' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_titular_poliza_decano[${index}]`, item);
      });
    } else if (key === 'files_dni_titular_poliza' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_dni_titular_poliza[${index}]`, item);
      });
    } else if (key === 'files_poliza_original' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_poliza_original[${index}]`, item);
      });
    } else if (key === 'files_renuncia_titular_poliza_decano' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_renuncia_titular_poliza_decano[${index}]`, item);
      });
    } else if (key === 'files_renuncia_dni_titular_poliza' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_renuncia_dni_titular_poliza[${index}]`, item);
      });
    } else if (key === 'files_renuncia_poliza_original' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_renuncia_poliza_original[${index}]`, item);
      });
    } else if (key === 'files_documento' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_documento[${index}]`, item);
      });
    } else if (key === 'beneficiarios' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        Object.keys(item).forEach((_key) => {
          formData.append(`beneficiarios[${index}][${_key}]`, item[_key]);

          if (data[key] && data[key].length > 0 && _key === 'files_dni') {
            data[key][index][_key].forEach((item, index_file) => {
              formData.append(`beneficiarios[${index}][${_key}][${index_file}]`, item);
            });
          }
        });
      });
    } else {
      formData.append(key, data[key]);
    }
  });

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${data.id}/actualizar`, {
    method: 'post',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const deleteReporte = (id, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${id}`, {
    method: 'delete',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const sendEmail = (id, data, success, error) => {
  const token = helper.getToken();

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key !== 'files') {
      if (typeof data[key] === 'object') {
        data[key].forEach((item, index) => {
          if (typeof item === 'object') {
            Object.keys(item).forEach((k) => {
              formData.append(`${key}[${index}][${k}]`, item[k]);
            });
          } else {
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else {
        formData.append(key, data[key]);
      }
    } else if (data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files[${index}]`, item);
      });
    }
  });

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${id}/email`, {
    method: 'post',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const createHabilitarReporte = (data, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === 'files' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files[${index}]`, item);
      });
    } else if (key === 'files_titulo' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_titulo[${index}]`, item);
      });
    } else if (key === 'files_fotografia' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_fotografia[${index}]`, item);
      });
    } else if (key === 'files_dni' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_dni[${index}]`, item);
      });
    } else if (key === 'files_poliza' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_poliza[${index}]`, item);
      });
    } else if (key === 'files_declaracion_jurada' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_declaracion_jurada[${index}]`, item);
      });
    } else if (key === 'files_declaracion_jurada_no_afiliacion' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_declaracion_jurada_no_afiliacion[${index}]`, item);
      });
    } else if (key === 'files_documento' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        formData.append(`files_documento[${index}]`, item);
      });
    } else if (key === 'beneficiarios' && data[key] && data[key].length > 0) {
      data[key].forEach((item, index) => {
        Object.keys(item).forEach((_key) => {
          formData.append(`beneficiarios[${index}][${_key}]`, item[_key]);

          if (data[key] && data[key].length > 0 && _key === 'files_dni') {
            data[key][index][_key].forEach((item, index_file) => {
              formData.append(`beneficiarios[${index}][${_key}][${index_file}]`, item);
            });
          }
        });
      });
    } else {
      formData.append(key, data[key]);
    }
  });

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes`, {
    method: 'post',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getReporteDocumentos = (id, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${id}/documentos`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getStoreClienteFind = (data, success, error) => {
  return fetch(
    `${apiConfig.constants.URL_NEGOCIOS}/api/v1/store/cliente/${data.numero_documento}?codigo_afiliado=${data.codigo_afiliado}`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  )
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getStoreClienteFindCuenta = (data, success, error) => {
  return fetch(`${apiConfig.constants.URL_NEGOCIOS}/api/v1/store/cliente/${data.numero_documento}`, {
    headers: {
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const getFindReporteHabilitado = (numero_documento, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(
    `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/Reportes/${numero_documento}/habilitados`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    }
  )
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const createCuentaMontoAdelantar = (data, success, error) => {
  const token = null;
  return fetch(`${apiConfig.constants.URL_NEGOCIOS}/api/v1/adelantos?codigo_afiliado=${data.codigo_afiliado}`, {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};


const getReportePagos = (queryString, success, error) => {
  const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

  return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/reporte/pagos${queryString}&empresa_id=${apiConfig.constants.EMPRESA_ID}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const exportedObject = {
  getReportes,
  getReporte,
  createReporte,
  updateReporte,
  deleteReporte,
  sendEmail,
  createHabilitarReporte,
  getReporteDocumentos,
  getStoreClienteFind,
  getStoreClienteFindCuenta,
  getFindReporteHabilitado,
  getReporteHC,
  getReportePagoPendiente,
  createCuentaMontoAdelantar,
  getReportePagos
};

export default exportedObject;
